import { IngredientWithDetails } from '../types/ingredient-types';
import { IngredientNutritionHistory } from './ingredient-nutrient-history';
import { IngredientNutrition } from './ingredient-nutrition';

interface IngredientNutritionProps {
  ingredient: IngredientWithDetails;
  isEditable: boolean;
}

export function IngredientNutritionTab({
  ingredient,
  isEditable,
}: IngredientNutritionProps) {
  return (
    <div className="pt-2">
      <IngredientNutrition ingredient={ingredient} isEditable={isEditable} />
      <IngredientNutritionHistory ingredientId={ingredient.id} />
    </div>
  );
}
